import { useEffect, useState } from "react";
import { Ban } from "lucide-react";
import { fetchAvoidTips } from "../../lib/api";
import { SectionHeader } from "./SectionHeader";

export const AvoidSection = () => {
  const [tips, setTips] = useState(null);

  useEffect(() => {
    fetchAvoidTips(6).then(setTips).catch(() => setTips([]));
  }, []);

  if (tips && tips.length === 0) return null;

  return (
    <section data-testid="home-avoid" className="mt-12 sm:mt-16">
      <SectionHeader
        icon={Ban}
        eyebrow="Don't waste your money"
        title="Where most people overspend"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {(tips || Array.from({ length: 6 })).map((t, i) =>
          t ? (
            <article
              key={t.title || i}
              data-testid={`home-avoid-tip-${i}`}
              className="bg-card border border-border rounded-2xl p-4 sm:p-5 hover-lift transition-colors hover:border-red-500/30"
            >
              <div className="flex items-start gap-3 mb-2">
                <div className="shrink-0 w-7 h-7 rounded-lg bg-red-500/10 border border-red-500/30 flex items-center justify-center">
                  <Ban className="w-3.5 h-3.5 text-red-400" />
                </div>
                <h3 className="font-display font-semibold text-sm sm:text-base text-foreground leading-tight">
                  {t.title}
                </h3>
              </div>
              <p className="text-xs sm:text-[13px] leading-relaxed text-muted-foreground">
                {t.tip}
              </p>
            </article>
          ) : (
            <div
              key={i}
              className="h-32 rounded-2xl bg-card border border-border animate-pulse"
            />
          ),
        )}
      </div>
    </section>
  );
};

export default AvoidSection;
